import { storeFolderConstants } from "actions/storeFoldersActions";

const initialState = {
	loading: false,
	items: [],
	error: null,
};

export function storeFoldersReducer(state = initialState, action) {
	switch (action.type) {
		case storeFolderConstants.GET_REQUEST:
			return {
				...state,
				loading: true,
			};
		case storeFolderConstants.GET_SUCCESS:
			return {
				...state,
				loading: false,
				items: action.payload,
			};
		case storeFolderConstants.GET_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
}
